module.exports = __webpack_public_path__ + "static/media/5_meringue_small.8931c865.jpg";